import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CardHeader from '@material-ui/core/CardHeader';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';

import Input from "../../../components/UI/Input/Input";
import{
    businessUserInputHandler,
    onSubmitBusinessUser,
    initializeAddBusinessUserForm,
    
} from '../../../actions/Business';
class AddBusinessUser extends Component{
    componentDidMount(){
        this.props.initializeAddBusinessUserForm();
    }
    render(){
        let {
            businessUserForm,
            businessUserLoaderStatus
        } = this.props.businessState;
        let{
            menuItems
        } = this.props.sidebarState;
        const formElementArray = [];
        for(let key in businessUserForm){
            formElementArray.push({
                id : key,
                config : businessUserForm[key]
            })
        }
        let form = (
            <FormGroup row>
                <Grid container spacing={24}>
                    {
                        formElementArray.map(formElement => (
                                <Grid item xs={12} sm = {6} key = {formElement.id}>
                                    <Input 
                                        key = {formElement.id}
                                        name = {formElement.config.elementConfig.label}
                                        elementType={formElement.config.elementType}
                                        elementConfig={formElement.config.elementConfig}
                                        value={formElement.config.value}
                                        menuItems = {formElement.config.menuItems}
                                        error = {formElement.config.errorStatus}
                                        helperText = {formElement.config.errorMessage}
                                        changed={(event) => this.props.businessUserInputHandler(formElement.id, event )}
                                        touched = {(event) => this.props.businessUserInputHandler(formElement.id, event )}
                                        maxLength={formElement.config.maxLength}
                                    />
                                </Grid>
                            
                        ))
                    }
                </Grid>
                <Grid container spacing={24} className = "pt-2">
                    <Grid item xs={10}>
                    </Grid>
                    <Grid item xs={2} className = "d-flex justify-content-end">
                        {
                            businessUserLoaderStatus ? <CircularProgress color = "primary" /> :
                            <Button
                                variant="contained" 
                                color="primary" 
                                disabled={false}
                                onClick = {() => this.props.onSubmitBusinessUser(businessUserForm, this.props, menuItems['business_user_list'].urlpattern)}
                            >
                                Submit
                            </Button>
                        }
                        

                    </Grid>
                </Grid>
            </FormGroup>
        )
        return(
            <div className = "container">
                <Card className = "pl-3 pr-3 pt-3">
                        <div>
                            <Grid container spacing={24} className = "pt-2">
                                <Grid item xs={12} sm = {10}>
                                    <CardHeader title="Add User"/>
                                </Grid>
                            </Grid>
                        </div>
                    <CardContent>
                        {form}
                    </CardContent>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        businessState : state.business,
        sidebarState : state.sidebarState
    }
}

const mapDispatchToProps = dispatch => {
    return{
        businessUserInputHandler : (inputFiledId, event) => {
            return dispatch(businessUserInputHandler(inputFiledId, event))
        },
        onSubmitBusinessUser : (businessUserForm, props, url) => {
            return dispatch(onSubmitBusinessUser(businessUserForm, props, url))
        },
        initializeAddBusinessUserForm : () => {
            return dispatch(initializeAddBusinessUserForm())
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddBusinessUser));